import React, { useEffect, useState } from "react";
import DivTag from "../../Components/DivComponent/DivTag";
import Button from "../../Components/ButtonComponent/Button";
import SelectWithLabelOption from "../../Components/SelectComponent/SelectWithLabelOption";
import ReportHeading from "../../Components/ReportHeadings/ReportHeadings";
import FormValidation from "../../Components/FormValidation/FormValidation";
import Option from "../../Components/OptionComponent/Option";
import { motion } from "framer-motion";
import ButtonReport from "../../Components/ButtonComponent/ButtonReport";
import ActivatePopup from "./ActivatePopup";
import printTable from "../../Components/TablePrintExcelPdfSearch/tablePrint";
import downloadExcel from "../../Components/TablePrintExcelPdfSearch/downloadExcel";
import downloadPdf from "../../Components/TablePrintExcelPdfSearch/downloadPdf";
import InputField from "../../Components/InputComponent/InputField";
import "jspdf-autotable";
import {
  RetriveServiceReportService,
  toggleService,
  RetriveServiceReportService2,
} from "../../../services/apiaddservice";
import UpdatePopUp from "./UpdatePopUp";
import { ToastContainer } from "react-toastify";
import { showErrorToast, showSuccessToast } from "../../../utils/toastUtils";
import ConfirmPopUp from "../../../components/Dialog/ConfirmPopup";
import Seo from "../../../components/SeoComponent/Seo";
import PaginationData from "../../../components/PaginationData";
import Loader from "../../../components/Loader/Loader";

const ActivateService = () => {
  //Activate Button PopUp Click
  const [isModalOpenActivatePopup, setIsModalActivatePop] = useState(false);
  const [isEditPopOpen, setIsEditPopOpen] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [isToggle, setIsToggle] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [paginationData, setPaginationData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [serviceData, setServiceData] = useState([]);
  const [filteredTableData, setFilteredTableData] = useState([]);
  const [selectedServiceName, setSelectedServiceName] = useState("");
  const [statusId, setStatusId] = useState("");
  const [selectedStatusId, setSelectedStatusId] = useState("");
  const [pageIndex, setPageIndex] = useState(0);

  const statusConfig = {
    5: { label: "Active", color: "#22c55e" },
    4: { label: "Inactive", color: "#eab308" },
    18: { label: "Deprecated", color: "#ef4444" },
    19: { label: "Coming Soon", color: "#3b82f6" },
  };

  const statusTransitions = {
    4: [5, 18, 19],
    5: [4, 18, 19],
    18: [4, 5],
    19: [4, 5],
  };

  // Function to open the modal
  const openActivatePopup = (id, endPoint, serviceName, statusId) => {
    setSelectedId(id);
    //  console.log("iddd",selectedId);
    setEndPoint(endPoint || ""); // fallback to empty if undefined
    setSelectedServiceName(serviceName);
    setSelectedStatusId(statusId);
    setIsModalActivatePop(true);
  };

  // Function to close the modal
  const onCloseActivatePop = () => {
    setIsModalActivatePop(false);
  };

  const initialState = {
    select_service: "",
  };

  const validate = (values) => {
    let errors = {};

    if (!values.select_service) {
      errors.select_service = "Select Service";
    }
    return errors;
  };

  const { values, errors, handleChange, handleBlur } = FormValidation(
    initialState,
    validate,
  );

  // Define default table data
  const [defaultTableData, setDefaultTableData] = useState([]);
  const [endPoint, setEndPoint] = useState([]);

  // Printing function starts here
  const handlePrint = () => {
    printTable("table");
  };
  // Printing Function Ends

  // Download function starts here
  const onDownloadExcel = () => {
    const headers = Object.keys(defaultTableData[0]).filter(
      (header) => header !== "Activate",
    );
    downloadExcel(headers, defaultTableData);
  };
  // Download function ends here

  // Download pdf function starts here
  const onDownloadPdf = () => {
    // Extract headers from the defaultTableData
    const headers = Object.keys(defaultTableData[0]).filter(
      (header) => header !== "Activate",
    );

    // Call downloadPdf with both defaultTableData and headers
    downloadPdf(defaultTableData, headers);
  };

  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchInputChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);

    // if (value.trim() === "") {
    //   setFilteredTableData(defaultTableData);
    //   return;
    // }

    // const filtered = defaultTableData.filter((item) =>
    //   item?.service_name?.toLowerCase().includes(value.toLowerCase()),
    // );

    // setFilteredTableData(filtered);
  };

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredTableData(defaultTableData);
      return;
    }

    console.log("page index", pageIndex);

    const timeout = setTimeout(() => {
      const filtered = defaultTableData.filter((item) =>
        item?.service_name?.toLowerCase().includes(searchQuery.toLowerCase()),
      );

      setFilteredTableData(filtered);
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, [searchQuery, pageIndex]);

  const handleUpdatePop = (id) => {
    setSelectedId(id);
    setIsEditPopOpen(true);
  };
  const handleToggle = (item, newStatusId) => {
    setSelectedId(item.id);
    setStatusId(newStatusId);
    setIsToggle(true);
  };

  const handleActivate = async () => {
    setIsLoading(true);
    try {
      const respnse = await toggleService({ selectedId, statusId });

      if (respnse.code === 200 || respnse.status.code === 200) {
        await loadService();
        showSuccessToast(respnse.message || respnse.status.message);
        setIsToggle(false);
        return;
      }
      setIsToggle(false);
      showErrorToast("Failed to activate ");
      return;
    } catch (error) {
      setIsToggle(false);
      showErrorToast("An Error occurs");
      setIsLoading(false);
      return;
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadService(currentPage);
  }, [currentPage]);

  useEffect(() => {
    loadService(currentPage);
  }, [isEditPopOpen]);

  const loadService = async (page = currentPage) => {
    setIsLoading(true);
    try {
      const response = await RetriveServiceReportService(page);
      if (response.status === "success") {
        const { data, pagination } = response;
        setDefaultTableData(data);
        setPageIndex((prev) => prev + 1);
        setPaginationData(pagination);
        setCurrentPage(pagination?.current_page);
        setLastPage(pagination?.last_page);
        const payoutService = data.find(
          (item) =>
            item.end_point && item.end_point.includes("/idfc/fund-transfer"),
        );

        if (payoutService?.end_point) {
          setEndPoint(payoutService?.end_point);
        } else {
          setEndPoint("");
        }
      }
    } catch (error) {
      console.error("Error fetching service report:", error);
      setIsLoading(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSetPage = (page) => {
    setCurrentPage(page);
  };

  async function retriveSrviceReport() {
    try {
      const response = await RetriveServiceReportService2({
        total_data: 200,
      });
      if (response.status === "success") {
        setServiceData(response.data || response);
        setIsLoading(false);
        return;
      }
    } catch (error) {
      setIsLoading(false);
      return;
    } finally {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    retriveSrviceReport();
  }, [isLoading]);
  // ENd

  useEffect(() => {
    if (!values.select_service) {
      setFilteredTableData(defaultTableData);
      return;
    }

    const filtered = defaultTableData.filter(
      (item) =>
        item.service_name?.toLowerCase() ===
        values.select_service?.toLowerCase(),
    );

    setFilteredTableData(filtered);
  }, [values.select_service, defaultTableData]);

  return (
    <motion.div
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1.2 }}
    >
      <Seo />
      {isLoading && <Loader />}
      <div
        className={
          isToggle
            ? "fixed inset-0 w-full h-full bg-black/30 backdrop-blur-sm flex items-center justify-center z-50"
            : ""
        }
      >
        <ConfirmPopUp
          visible={isToggle}
          onClose={() => setIsToggle(false)}
          onConfirm={handleActivate}
          title={"Click Yes to Continue the submission. No For Cancel?"}
        />
      </div>
      <DivTag
        id=""
        className="border-2 border-solid border-blue-800 rounded-xl mt-10 bg-white"
      >
        <ReportHeading name="Activate Services" />

        <DivTag className="flex flex-col md:flex-row justify-center items-center mt-1 gap-3">
          {/* Select Service Dropdown */}
          <SelectWithLabelOption
            DivclassName="w-full md:w-1/4"
            label="Select Service"
            id="select_service"
            name="select_service"
            value={values.select_service}
            onChange={handleChange}
            onBlur={handleBlur}
            required={true}
            className={
              errors.select_service
                ? "border border-red-500"
                : "border border-blue-600"
            }
            error={errors.select_service}
          >
            <Option value="" disabled>
              Select Service
            </Option>

            {serviceData.length > 0 &&
              serviceData.map((item, index) => (
                <Option key={index} value={item.service_name}>
                  {item.service_name}
                </Option>
              ))}
          </SelectWithLabelOption>

          {/* OR text */}
          <span className="font-semibold text-gray-600">OR</span>

          <InputField
            type="text"
            value={searchQuery}
            onChange={handleSearchInputChange}
            placeholder="Search By Service Name..."
            className="appearance-none block text-gray-700 border 
  rounded px-2 py-1 border-blue-400 focus:bg-white text-center w-full md:w-1/4"
          />

          {/* Clear Button */}
          <DivTag className="w-full md:w-1/5 md:mt-0 mt-4">
            <ButtonReport
              type="button"
              id="submit"
              name="submit"
              text="Clear"
              onClick={() => {
                // Reset dropdown
                handleChange({
                  target: {
                    name: "select_service",
                    value: "",
                  },
                });

                // Reset search input
                setSearchQuery("");

                // Reset table data
                setFilteredTableData(defaultTableData);
              }}
            />
          </DivTag>
        </DivTag>

        {/* <HeadingTag className="text-2xl text-blue-800 font-bold bg-white text-center" text="Report" /> */}

        <UpdatePopUp
          visible={isEditPopOpen}
          onClose={() => setIsEditPopOpen(false)}
          selectedId={selectedId}
        />

        <div className="flex w-full justify-center overflow-x-auto mt-2">
          <table className="min-w-[700px] w-full">
            <thead>
              <tr className="bg-gradient-to-r from-blue-900 via-blue-700 to-blue-900 text-white text-center text-sm">
                <th className="p-1 border border-blue-300 font-semibold">
                  Service Category
                </th>
                <th className="p-1 border border-blue-300 font-semibold">
                  Service Name
                </th>
                <th className="p-1 border border-blue-300 font-semibold">
                  Vendor Name
                </th>

                <th className="p-1 border border-blue-300 font-semibold">
                  End Point
                </th>

                <th className="p-1 border border-blue-300 font-semibold">
                  Method
                </th>

                <th className="p-1 border border-blue-300 font-semibold">
                  Per Hit Cost
                </th>

                <th className="p-1 border border-blue-300 font-semibold">
                  Status
                </th>
                <th className="p-1 border border-blue-300 font-semibold">
                  Preference
                </th>
                <th className="p-1 border border-blue-300 font-semibold">
                  Service Creation Date
                </th>
                <th className="p-1 border border-blue-300 font-semibold">
                  Action
                </th>
                <th className="p-1 border border-blue-300 font-semibold">
                  Status Toggle
                </th>
                <th className="p-1 border border-blue-300 font-semibold rounded-tr-lg">
                  Activation Service
                </th>
              </tr>
            </thead>

            <tbody className="overflow-y-scroll w-80">
              {filteredTableData?.length > 0 ? (
                filteredTableData.map((item, index) => (
                  <tr key={(currentPage - 1) * lastPage + index + 1}>
                    <td className="text-center whitespace-nowrap border text-[10px] font-semibold">
                      {item?.service_category?.name || "-"}
                    </td>
                    <td className="text-center whitespace-nowrap border font-semibold">
                      {item?.service_name || "-"}
                    </td>
                    <td className="text-center whitespace-nowrap border text-xs font-semibold">
                      {item?.vendor?.name || "-"}
                    </td>
                    {/* <td className="text-center whitespace-nowrap border text-xs font-semibold">
                      {item?.end_point || "-"}
                    </td> */}

                    <td className="text-center border text-[10px] font-semibold  pl-1 pr-1 truncate">
                      <span title={item?.end_point}>
                        {item?.end_point || "-"}
                      </span>
                    </td>
                    <td className="text-center whitespace-nowrap border text-sm font-semibold ">
                      {item?.method || "-"}
                    </td>
                    <td className="text-center whitespace-nowrap border text-sm font-semibold">
                      {item?.per_hit_cost || "-"}
                    </td>
                    <td className="whitespace-nowrap text-center p-1">
                      <button
                        type="button"
                        style={{
                          backgroundColor: statusConfig[item.status_id]?.color,
                        }}
                        className={`text-xs text-white px-2 py-0 rounded-xl border 
     `}
                      >
                        {item?.status.value}
                      </button>
                    </td>
                    <td
                      className={`text-center whitespace-nowrap border text-[10px] font-semibold  ${item?.preference === "Highly Recommended" && "preferece-class z-20"}
    ${item?.preference === "None" ? "text-red-500" : ""}
    ${item?.preference === "Recommended" ? "text-green-400" : ""}
    ${item?.preference === "Highly Recommended" ? "text-green-700" : ""}
  `}
                    >
                      {item?.preference}
                    </td>

                    <td className="text-center whitespace-nowrap border text-sm font-semibold">
                      {item?.created_at.substring(0, 10)}
                    </td>
                    <td className="whitespace-nowrap border text-sm text-center">
                      <Button
                        type=""
                        className="text-white bg-red-500 rounded-sm px-1 py-0 text-xs  hover:bg-blue-400 hover:text-white"
                        id="activate"
                        name="Edit"
                        onClick={() => handleUpdatePop(item.id)}
                        text="Edit"
                      />
                    </td>
                    <td className="whitespace-nowrap border pl-4 text-xs text-center">
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <select
                          className="border rounded px-2 py-1 text-white cursor-pointer"
                          style={{
                            backgroundColor:
                              statusConfig[item.status_id]?.color,
                          }}
                          value={item.status_id}
                          onChange={(e) =>
                            handleToggle(item, Number(e.target.value))
                          }
                        >
                          {Object.entries(statusConfig)
                            .filter(([key]) => {
                              const current = item.status_id;
                              const allowed = statusTransitions[current] || [];
                              return (
                                Number(key) === current ||
                                allowed.includes(Number(key))
                              );
                            })
                            .map(([key, val]) => (
                              <option key={key} value={key}>
                                {val.label}
                              </option>
                            ))}
                        </select>
                      </div>
                    </td>

                    <td className="text-center whitespace-nowrap border text-sm">
                      {item?.Activate}
                      <button
                        type="button"
                        id="activate"
                        name="activate"
                        onClick={() =>
                          openActivatePopup(
                            item?.id,
                            item?.end_point,
                            item?.service_name,
                            item?.status_id,
                          )
                        }
                        className="text-white text-md font-semibold px-1 py-0 rounded-md bg-gradient-to-r from-green-500 via-green-400 to-blue-500 hover:from-blue-500 hover:to-green-400 transition-all duration-300 shadow-md hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-blue-300"
                      >
                        Activate
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="px-4 py-2 text-center text-xl">
                    Data Not Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="flex justify-center my-2">
          <PaginationData
            currentPage={currentPage}
            lastPage={paginationData?.last_page}
            handlePage={handleSetPage}
          />
        </div>
      </DivTag>
      {isModalOpenActivatePopup && (
        <ActivatePopup
          serviceId={selectedId}
          endPoint={endPoint}
          serviceName={selectedServiceName}
          statusId={selectedStatusId}
          onCloseActivatePop={onCloseActivatePop}
        />
      )}{" "}
      {/* Render the modal */}
      <ToastContainer />
    </motion.div>
  );
};

export default ActivateService;
